import { PageLayout } from '@mews-commander/ui';
import { BusinessError, lt } from '@mews/framework';
import { IconBackButton } from '../components/generateContract/components/IconBackButton';
import { GenerateContractProps } from '../components/generateContract/types';
import { ContractsTextKey as TextKey } from '../ContractsTextKey';
import { GenerateContractSteppedForm } from '../components/generateContract/forms/GenerateContractSteppedForm';
import { GenerateContractProvider } from '../components/generateContract/context/GenerateContractProvider';

export const GenerateContract = (props: GenerateContractProps) => {
    if (props.customerId == null && props.reservationId == null) {
        throw new BusinessError('Either customerId or reservationId must be provided');
    }

    return (
        <GenerateContractProvider {...props}>
            <PageLayout
                // TODO: Add guide link when available
                guideLink=""
                titlePrefixSlot={<IconBackButton />}
                pageTitle={lt(TextKey.ContractsGenerateContractTitle)}
                padded
            >
                <GenerateContractSteppedForm />
            </PageLayout>
        </GenerateContractProvider>
    );
};
